<div class="container">
  <div class="denied-container">
    <img src="./assets/shell/denied-logout.svg" width="250" height="250" alt="" /> <br />
    @if (checkBrowserLanguage(['pt'])) {
      <span class="denied-title">Desculpe! ;(</span
        >
      }
      @if (checkBrowserLanguage(['es'])) {
        <span class="denied-title">Perdon! ;(</span
          >
        }
        @if (!checkBrowserLanguage(['pt', 'es'])) {
          <span class="denied-title">Sorry! ;(</span
            >
            }<br />
            @if (checkBrowserLanguage(['pt'])) {
              <span class="denied-text">Seu usuário não está autorizado a acessar o sistema.</span>
            }
            @if (checkBrowserLanguage(['es'])) {
              <span class="denied-text">Su usuario no está autorizado para acceder al sistema.</span>
            }
            @if (!checkBrowserLanguage(['pt', 'es'])) {
              <span class="denied-text">Your user is not authorized to access the system.</span>
            }
            <br />
            @if (checkBrowserLanguage(['pt'])) {
              <div class="denied-text">
                Tente se
                <a class="denied-link2" (click)="logout()">desconectar</a
                  ><span class="denied-text"> para depois se </span>
                  <a class="denied-link" (click)="logout()">conectar novamente</a
                    ><span class="denied-text"> com outro usuário.</span>
                  </div>
                }
                @if (checkBrowserLanguage(['es'])) {
                  <div class="denied-text">
                    Intente
                    <a class="denied-link2" (click)="logout()">desconectarse</a
                      ><span class="denied-text"> y luego </span>
                      <a class="denied-link" (click)="logout()">conectarse nuevamente</a
                        ><span class="denied-text"> con otro usuario.</span>
                      </div>
                    }
                    @if (!checkBrowserLanguage(['pt', 'es'])) {
                      <div class="denied-text">
                        Try to
                        <a class="denied-link2" (click)="logout()">disconnect</a
                          ><span class="denied-text"> and </span>
                          <a class="denied-link" (click)="logout()">connect again</a
                            ><span class="denied-text"> with other user.</span>
                          </div>
                        }
                      </div>
                    </div>
